// extracted by mini-css-extract-plugin
export default {"editTableButton":"offer_editTableButton__6Roc+","patientForm":"offer_patientForm__ZnOX0","chosenRow":"offer_chosenRow__t5O8D","errorMessage":"offer_errorMessage__2andP"};